<template>
    <v-btn-toggle v-model="index" mandatory dense :class="`${$options.name}__ButtonSize`">
        <v-btn
            v-for="count in displayCount"
            :key="count"
            :ref="count"
            :disabled="isDisabled"
            text
            color="accent"
            class="pt-1"
        >
            {{ count }}
        </v-btn>
    </v-btn-toggle>
</template>

<script lang="ts">
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'CountButton',
})
export default class CountButton extends Vue {
    @Prop({ default: false }) disabled: boolean;
    @Watch('index')
    onIndexChanged(val: number): void {
        this.$emit('count', this.displayCount[val]);
    }

    displayCount = [10, 20, 50, 100];
    index = 0;

    get isDisabled(): boolean {
        return this.disabled;
    }
}
</script>

<style lang="scss" scoped>
.CountButton {
    &__ButtonSize {
        .v-btn.v-size--default {
            min-width: 2.5rem !important;
        }
    }
}
</style>
